import * as API from "@/services/API"

export default {
    getSucursal(sucId) {
        return API.apiClient.get(`/sucursales/${sucId}`)
    },
    getSucursales() {
        return API.apiClient.get(`/sucursales/list`)
    }
}